require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-neusiedl-tadten.json") })
        }
      }, "path---betreuungseinrichtungen-neusiedl-tadten");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-neusiedl-tadten!./.cache/json/betreuungseinrichtungen-neusiedl-tadten.json
// module id = 965
// module chunks = 231608221292675